import { Button } from '@mui/material'
import { CustomTableData } from 'common'
import { TooltipInformation } from 'common'
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import { Edit3, Trash2 } from 'react-feather'


export const CollateralTable = ({ useFetchInit }) => {

    const {
        globalStates,
        FetchData,
        Actions,
        Forms
    } = useFetchInit


    const { fetchAllCollateral: { collateral } } = FetchData

    // const {handleClickDeleteDeposit, handleClickFetchInfoDeposit} = Actions
    const { modalOpeningMode, formOpeningMode } = globalStates

    const { FormRequestGlobal: { formState } } = Forms

    const { handleClickFetchInfoCollateral, handleClickDeleteCollateral } = Actions



    const columnConfig = [
        {
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { idvehicledeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <>
                        <TooltipInformation
                            idregistro={idvehicledeposit}
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>

                )
            }
        },
        { field: "type_collateral", headerName: "TIPO DE GARANTIA", minWidth: 300, filter: true },
        { field: "title", headerName: "TITLE", minWidth: 500, filter: true },
        { field: "valor", headerName: "VALOR (Q)", minWidth: 130, filter: true },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idcollateral } = params.data

                return (
                    <>
                        <Button
                            variant='contained'
                            size='small'
                            onClick={() => handleClickFetchInfoCollateral(idcollateral, 'READONLY')}
                            color='info'
                            style={{ marginRight: '0.4vh' }}  >
                            <i className="fa-solid fa-info-circle" style={{ marginRight: '8px' }}></i> Ver Detalles
                        </Button>
                    </>
                )

            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData
                // rowConfig={[]}
                rowConfig={collateral}
                columnConfig={columnConfig}
            />
        </div>
    )
}